import BrandCard from "./BrandCard";
import useBrand from "../../../../clients/brands/useBrand";

export default function BrandCardContainer(props) {
    const { Component = BrandCard, id, ...restProps } = props;

    const brand = useBrand(id)?.data?.brand;

    return (
        <Component
            id={ brand.id }
            name={ brand.name }
            { ...restProps }
        />
    );
}
